import z from 'zod'

export enum ApplicationAccountUserStatus {
  CONNECT = 'CONNECT',
  AUTHENTICATE = 'AUTHENTICATE',
  CONNECTED = 'CONNECTED',
  REMOVED = 'REMOVED',
}

export enum ApplicationAccountUserRole {
  OWNER = 'OWNER',
  ADMIN = 'ADMIN',
  MANAGER = 'MANAGER',
  OPERATOR = 'OPERATOR',
  FINANCIAL = 'FINANCIAL',
}

export const applicationAccountUserModel = z.object({
  __typename: z
    .literal('ApplicationAccountUser')
    .default('ApplicationAccountUser'),
  id: z.string(),
  applicationId: z.string(),
  userId: z.string(),
  accountId: z.string().nullable(),
  externalUserId: z.string().nullable(),
  externalAccountId: z.string().nullable(),
  role: z.nativeEnum(ApplicationAccountUserRole),
  startDate: z.string().datetime(),
  endDate: z.string().datetime().nullable(),
  status: z.nativeEnum(ApplicationAccountUserStatus),
  metadata: z.record(z.string()),
  isIngress: z.boolean(),
})

export type ApplicationAccountUserModel = z.infer<
  typeof applicationAccountUserModel
>
